import React from "react";
import { Bell, BellOff } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { usePushNotifications } from "../hooks/usePushNotifications";
import { toast } from "sonner";

export default function NotificationBell() {
  const { t } = useLanguage();
  const { permission, isSubscribed, isSupported, loading, subscribe, unsubscribe } = usePushNotifications();

  if (!isSupported || permission === "denied") return null;

  const handleToggle = async () => {
    if (isSubscribed) {
      await unsubscribe();
      toast.info(t("push.disabled_toast"));
    } else {
      const ok = await subscribe();
      if (ok) toast.success(t("push.enabled_toast"));
      else if (permission === "denied") toast.error(t("push.denied_toast"));
    }
  };

  return (
    <button
      onClick={handleToggle}
      disabled={loading}
      className={`flex items-center justify-center w-8 h-8 transition-all ${
        isSubscribed
          ? "text-[#C17F59] hover:text-[#A86A46]"
          : "text-[#C8C0B8] hover:text-[#9A8F86]"
      }`}
      title={isSubscribed ? t("push.disable_btn") : t("push.enable_btn")}
      data-testid="notification-bell-btn"
      style={{ background: "none", border: "none", cursor: loading ? "wait" : "pointer" }}
    >
      {isSubscribed ? (
        <Bell size={17} strokeWidth={1.5} />
      ) : (
        <BellOff size={17} strokeWidth={1.5} />
      )}
    </button>
  );
}
